import { createContext, ReactNode, useState, useEffect } from "react";

const defaultValue = {
  metamaskAccountAddress: '',
  setMetamaskAccountAddress: (newValue: string) => { },
}

export const MetamaskContext = createContext(defaultValue)

export const MetamaskContextProvider = (props: { children: ReactNode | undefined }) => {
  const [metamaskAccountAddress, setMetamaskAccountAddress] = useState('')

  // Load persisted connection state on mount
  useEffect(() => {
    const persistedAddress = localStorage.getItem('metamask_accountAddress');
    if (persistedAddress) {
      setMetamaskAccountAddress(persistedAddress);
    }
  }, []);

  // Persist connection state when it changes
  const handleSetMetamaskAccountAddress = (newValue: string) => {
    setMetamaskAccountAddress(newValue);
    if (newValue) {
      localStorage.setItem('metamask_accountAddress', newValue);
    } else {
      localStorage.removeItem('metamask_accountAddress');
    }
  };

  return (
    <MetamaskContext.Provider
      value={{
        metamaskAccountAddress,
        setMetamaskAccountAddress: handleSetMetamaskAccountAddress
      }}
    >
      {props.children}
    </MetamaskContext.Provider>
  )
}
